import { render } from "./Switchin.vue?vue&type=template&id=8c269a3a&scoped=true"
import script from "./Switchin.vue?vue&type=script&lang=js"
export * from "./Switchin.vue?vue&type=script&lang=js"

import "./Switchin.vue?vue&type=style&index=0&id=8c269a3a&lang=css"
import "./Switchin.vue?vue&type=style&index=1&id=8c269a3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c269a3a"]])

export default __exports__